export const INDEX_PATH = '/';

export const REFERRAL_CODE_QUERY_PARAM_NAME = 'utm_referral';
